module.exports = require('./lib/gravatar');



//////////////////
// WEBPACK FOOTER
// ./~/gravatar/index.js
// module id = 219
// module chunks = 0